/* Round 3 (16 Oct 2026): + ATC price, gallery dots/counter, stock sync. */
/* Fitlybuy PDP v2 (LIVE: product.mifo.json only; also PREVIEW, 16 Oct 2026): sticky Add to cart + closing CTA.
   Both proxy buttons click the real Dawn Add to cart button, so variant choice, cart drawer, sold-out state and
   app tracking all keep working exactly as before. No product data is read or written. */
(function () {
  function mainInfo() { return document.querySelector('product-info[id^="MainProduct-"]'); }
  function mainBtn() { var i = mainInfo(); return i && i.querySelector('form[data-type="add-to-cart-form"] [name="add"]'); }
  function init() {
    var info = mainInfo(); var btn = mainBtn();
    var bar = document.querySelector('[data-fb2-sticky]');
    var proxies = document.querySelectorAll('[data-fb2-atc]');
    if (!info || !btn) { if (bar) bar.remove(); return; }
    function sync() {
      var b = mainBtn(); if (!b) return;
      var disabled = b.disabled || b.getAttribute('aria-disabled') === 'true';
      var lab = (b.querySelector('span') || b).textContent.trim() || 'Add to cart';
      var priceEl = info.querySelector('[id^="price-"] .price__regular .price-item--regular') || info.querySelector('[id^="price-"] .price-item--last') || info.querySelector('[id^="price-"] .price-item');
      var price = priceEl ? priceEl.textContent.trim() : null;
      var checked = info.querySelectorAll('variant-selects input:checked, variant-selects select');
      var vt = [];
      checked.forEach(function (el) { vt.push(el.tagName === 'SELECT' ? el.options[el.selectedIndex].text.trim() : el.value); });
      proxies.forEach(function (p) {
        p.disabled = disabled;
        var l = p.querySelector('[data-fb2-label]'); if (l && l.textContent !== lab) l.textContent = lab;
      });
      document.querySelectorAll('[data-fb2-price]').forEach(function (e) { if (price && e.textContent !== price) e.textContent = price; });
      document.querySelectorAll('[data-fb2-stock]').forEach(function (e) { if (e.hidden !== !!b.disabled) e.hidden = !!b.disabled; });
      if (!b.querySelector('.fb2-atc-price')) atcPrice();
      var vEl = document.querySelector('[data-fb2-variant]');
      if (vEl && vt.length && vEl.textContent !== vt.join(' / ') + ' · ') vEl.textContent = vt.join(' / ') + ' · ';
    }
    proxies.forEach(function (p) {
      p.addEventListener('click', function () {
        var b = mainBtn(); if (!b || b.disabled) return;
        b.click();
      });
    });
    if (bar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        document.body.classList.toggle('fb2-has-sticky', past);
      }, { threshold: 0 });
      io.observe(btn);
      var observed = btn;
      new MutationObserver(function () {
        var b = mainBtn();
        if (b && b !== observed) { io.unobserve(observed); io.observe(b); observed = b; }
        sync();
      }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'checked'] });
    }
    info.addEventListener('change', function () { setTimeout(sync, 50); });
    sync();
    atcPrice(); gallery();
  }
  /* Round 3 (16 Oct 2026): price + arrow inside the real Add to cart button (mifo style). Label span stays first so Dawn keeps updating it. */
  function atcPrice() {
    var b = mainBtn(); if (!b || b.querySelector('.fb2-atc-price')) return;
    var s = document.createElement('span'); s.className = 'fb2-atc-price'; s.setAttribute('aria-hidden', 'true');
    var src = document.querySelector('.fb2-summary [data-fb2-price]');
    s.innerHTML = '<span data-fb2-price></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    s.firstChild.textContent = src ? src.textContent : '';
    var spin = b.querySelector('.loading__spinner');
    if (spin) b.insertBefore(s, spin); else b.appendChild(s);
  }
  /* Round 3: mifo gallery controls - counter pill on the image, circle arrows at both ends, dots. Drives Dawn's own MediaGallery. */
  function gallery() {
    var info = mainInfo(); if (!info) return;
    var mg = info.querySelector('media-gallery'); if (!mg || mg.querySelector('.fb2-gal')) return;
    var viewer = mg.querySelector('[id^="GalleryViewer"]'); if (!viewer) return;
    var items = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;
    var cur = Math.max(0, items.findIndex(function (e) { return e.classList.contains('is-active'); }));
    var svgL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>';
    var svgR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"/></svg>';
    var bar = document.createElement('div'); bar.className = 'fb2-gal';
    var html = '<button type="button" class="fb2-gal__arrow" data-dir="-1" aria-label="Previous image">' + svgL + '</button><div class="fb2-gal__dots">';
    items.forEach(function (_, i) { html += '<button type="button" class="fb2-gal__dot" data-i="' + i + '" aria-label="Show image ' + (i + 1) + ' of ' + items.length + '"></button>'; });
    html += '</div><button type="button" class="fb2-gal__arrow" data-dir="1" aria-label="Next image">' + svgR + '</button>';
    bar.innerHTML = html;
    var count = document.createElement('span'); count.className = 'fb2-gal__count'; count.setAttribute('aria-hidden', 'true');
    viewer.insertAdjacentElement('afterend', bar); mg.appendChild(count);
    var dots = bar.querySelectorAll('.fb2-gal__dot');
    function paint(i) {
      cur = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      count.textContent = (i + 1) + ' / ' + items.length;
    }
    function go(i) {
      i = (i + items.length) % items.length; paint(i);
      var id = items[i].dataset.mediaId;
      if (typeof mg.setActiveMedia === 'function') mg.setActiveMedia(id, false);
      else items[i].parentElement.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
    }
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.dataset.dir) go(cur + parseInt(t.dataset.dir, 10)); else go(parseInt(t.dataset.i, 10));
    });
    viewer.addEventListener('slideChanged', function (e) {
      var el = e.detail && e.detail.currentElement; var i = items.indexOf(el);
      if (i < 0 && e.detail && e.detail.currentPage) i = e.detail.currentPage - 1;
      if (i >= 0 && i !== cur) paint(i);
    });
    var list = viewer.querySelector('.product__media-list');
    if (list) {
      var t0; list.addEventListener('scroll', function () {
        clearTimeout(t0); t0 = setTimeout(function () {
          if (window.innerWidth >= 750) return;
          var w = items[0].offsetWidth || 1; var i = Math.round(list.scrollLeft / w);
          if (i >= 0 && i < items.length && i !== cur) paint(i);
        }, 80);
      }, { passive: true });
    }
    paint(cur);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
